/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Payor/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Discounts from './Discounts/index'
import Person from './Person/index'
import React from 'react'
import ShareAfterDiscounts from './ShareAfterDiscounts/index'
import ShareBeforeDiscounts from './ShareBeforeDiscounts/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Payor({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Summary/Payors/Payor"
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Payor.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-5xK8b': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--ml-2-5xK8b': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-3-5xK8b': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<Person
  viewPath={`${viewPath}/Person`}
/>
<ShareBeforeDiscounts
  viewPath={`${viewPath}/ShareBeforeDiscounts`}
/>
</div>
<Discounts
  viewPath={`${viewPath}/Discounts`}
/>
<ShareAfterDiscounts
  viewPath={`${viewPath}/ShareAfterDiscounts`}
/>
{children}
</React.Fragment>)
}